interface ISizedBox {
    width?: number | string;
    height?: number | string;
}

export const SizedBox = ({ width = 1, height = 0 }: ISizedBox) => (
    <div style={{ width, height }} />
);
